import { Trip } from './../classes.js';
import { get_marker_color } from './../vars/icons.js';
import { event_timestamp } from './../function/common.js';

export function calendar__element(data){
	let $content = '';
	let $day = '';
	let $entries = '';
	let background_color = 'primary';
	let events = [];
	let sortedEvents = [];
	let start_date_loop = new Date(data.trip.start_date);
	let end_date_loop = new Date(data.trip.end_date);
	
	
	//get the events for this trip
	const sortedBlocks = Object.entries(data.b).sort((a, b) => a[1]['order'] - b[1]['order']);
	for (const [block_id, block] of sortedBlocks) {
		
		const sortedElements = Object.entries(block.e).sort((a, b) => a[1]['order'] - b[1]['order']);
		
		for (const [el_id, el] of Object.entries(block.e)) {
			if(el.type == 'event' && el.c.date != ''){
				if(typeof(events[el.c.date]) == 'undefined'){
					events[el.c.date] = [];
				}
				events[el.c.date].push(el);
			}
		}
	}
	
	for (const [key, ev] of Object.entries(events)) {
		
		sortedEvents[key] = Object.entries(ev).sort((a, b) => {
			return event_timestamp(a[1]['c']['date']+' '+a[1]['c']['time_hour']+':'+a[1]['c']['time_minute']+' '+a[1]['c']['time_ampm']) - event_timestamp(b[1]['c']['date']+' '+b[1]['c']['time_hour']+':'+b[1]['c']['time_minute']+' '+b[1]['c']['time_ampm'])
		});
	}
	
	//build the display for the calendar
	$content = $('<div/>', {
		'class': 'e trip__calendar',
		'data-el_id': 'calendar',
		'data-block_id': 'trip'
	});
	
	while (start_date_loop <= end_date_loop) {
		
		const mm = String(start_date_loop.getMonth() + 1).padStart(2, '0');
		const dd = String(start_date_loop.getDate()).padStart(2, '0');
		const yyyy = start_date_loop.getFullYear();
		const formatted_date = `${mm}/${dd}/${yyyy}`;
		
		$day = $('<div/>', {
			'class': 'calendar__day',
		});
		
		$day.append(`
			<div class="day__title">
				${formatted_date}
			</div>
		`);
		
		if(typeof(sortedEvents[formatted_date]) != 'undefined'){
			$entries = $('<div/>', {
				'class': 'day__events',
			});
			
			for (const ev of Object.entries(sortedEvents[formatted_date])) {
				let ev_array = ev[1][1];
				background_color = get_marker_color(Trip.styles[ev_array.c.style].category);
				
				$entries.append(
					`<div class="calendar__entry bg--${background_color}">
						<div class="calendar__entry--timestamp">
							${ev_array.c.time_hour}:${ev_array.c.time_minute}${ev_array.c.time_ampm}
						</div>
						<div class="calendar__entry--title">
							${ev_array.c.name}
						</div>
					</div>`
				);
				
			}
			
			$day.append($entries);
			$content.append($day);
		}
		
		start_date_loop.setDate(start_date_loop.getDate() + 1);
	}
	
	
	
	return $content;
}
